import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
export const useGetInterestedPolicyFilterDataQuery = () => {
  const $ = _c(3);
  const isLogin = useAuthStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthQueryOptions["get:/wello/v2/auth/member-filter/interest"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLogin) {
    t1 = {
      ...t0,
      enabled: isLogin,
      select: _temp2
    };
    $[1] = isLogin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
};
function _temp(state) {
  return !!state.isLogin;
}
function _temp2(t0) {
  const {
    context
  } = t0;
  return context?.codeList;
}